import { render, staticRenderFns } from "./DataFields.vue?vue&type=template&id=b435aba0&scoped=true"
import script from "./DataFields.vue?vue&type=script&lang=ts"
export * from "./DataFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b435aba0",
  null
  
)

export default component.exports